module.exports = __webpack_public_path__ + "assets/icons/ic_schedule_24px.svg";